import {
  message
} from 'antd';
import { AxiosError } from 'axios';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

import CreateEmployee from 'common/components/CreateEmployee';
import { getStaffService } from 'common/services/extends/staff';

const EmployeeDetail: React.FC<ActiveRoles> = ({
  roleIndex,
  ...props
}) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  /* States */
  const idParams = Number(searchParams.get('id'));

  /* Queries */
  const { data: staffDetailRes, isLoading: detailLoading } = useQuery(
    ['get-staff-detail', idParams],
    () => getStaffService(idParams),
    {
      enabled: !!idParams && roleIndex,
      onError: (errors: unknown) => {
        if (errors instanceof AxiosError) {
          message.error(
            errors.response?.data?.message || t('message.anErrorHasOccurred')
          );
        }
      },
    }
  );

  return (
    <CreateEmployee
      {...props}
      roleIndex={roleIndex}
      data={staffDetailRes}
      loading={detailLoading}
    />
  );
};

export default EmployeeDetail;
